var Acount = /** @class */ (function () {
    function Acount(props) {
        Object.assign(this, props);
        if (props.collaborator) {
            this.collaborator = new AcountCollaborator(props.collaborator);
            delete this.collaborator['created_at'];
        }
    }
    return Acount;
}());
export default Acount;
var AcountCollaborator = /** @class */ (function () {
    function AcountCollaborator(props) {
        // created_at: Date
        this.disabled_at = null;
        Object.assign(this, props);
    }
    return AcountCollaborator;
}());
export { AcountCollaborator };
export var Modules = Object.freeze({
    Collaborator: 'moduleCollaborator',
    Virtual: 'moduleVirtual',
    Ecommerce: 'moduleEcommerce',
    App: 'moduleApp',
    Marketing: 'moduleMarketing',
    Civitrip: 'moduleCivitrip',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/Model.ts
// module id = 328
// module chunks = 0